import { GameMapControl } from "../../lib/gamemap/GameMapControl";
import { Path } from "../../lib/runescape/pathing";
import { MovementAbilities, MovementAssumptions } from "../../lib/runescape/movement";
import { DrawAbilityInteraction } from "./interactions/DrawAbilityInteraction";
import DrawRunInteraction from "./interactions/DrawRunInteraction";
import PlacePowerburstInteraction from "./interactions/PlacePowerburstInteraction";
import { ActionBar } from "../ui/map/ActionBar";
import { observe } from "../../lib/reactive";
import PlaceRedClickInteraction from "./interactions/PlaceRedClickInteraction";
import ControlWithHeader from "../ui/map/ControlWithHeader";
import { DrawCheatInteraction } from "./interactions/DrawCheatInteraction";
import { DrawCosmeticInteraction } from "./interactions/DrawCosmeticInteraction";
var movement_state = Path.movement_state;
var ActionBarButton = ActionBar.ActionBarButton;
export default class PathEditActionBar extends GameMapControl {
    constructor(editor, interaction_guard) {
        super({
            position: "bottom-center",
            type: "gapless"
        }, new ControlWithHeader("Path Editor"));
        this.editor = editor;
        this.interaction_guard = interaction_guard;
        this.state = observe(movement_state.start({}));
        // Render action bar
        {
            let self = this;
            function interact(interaction) {
                return self.interaction_guard.set(interaction
                    .onStart(() => self.editor.overlay_control.lens_layer.enabled2.set(false))
                    .onEnd(() => self.editor.overlay_control.lens_layer.enabled2.set(true)), self);
            }
            async function ability_handle(opt) {
                if (opt.predictor && self.state.value().position?.tile != null && self.state.value().position?.direction != null) {
                    let res = await opt.predictor(self.state.value().position);
                    if (res) {
                        self.editor.value.add(({
                            type: "ability",
                            ability: opt.ability,
                            from: self.state.value().position?.tile,
                            to: res.tile
                        }));
                        return;
                    }
                }
                return interact(new DrawAbilityInteraction(opt.ability, self.editor.value.assumptions())
                    .onCommit((step) => self.editor.value.add(step))
                    .setStartPosition(self.state.value().position?.tile));
            }
            this.buttons = {
                surge: new ActionBarButton('assets/icons/surge.png', () => ability_handle({ ability: "surge", predictor: MovementAbilities.surge }))
                    .tooltip("Surge")
                    .setHotKey("s-W"),
                escape: new ActionBarButton('assets/icons/escape.png', () => ability_handle({
                    ability: "escape",
                    predictor: pos => MovementAbilities.escape(pos, MovementAssumptions.escapeRange(this.editor.value.assumptions()))
                }))
                    .tooltip("Escape")
                    .setHotKey("s-S"),
                dive: new ActionBarButton('assets/icons/dive.png', () => ability_handle({ ability: "dive" }))
                    .tooltip("Dive")
                    .setHotKey("D"),
                barge: new ActionBarButton('assets/icons/barge.png', () => ability_handle({ ability: "barge" }))
                    .tooltip("Barge")
                    .setHotKey("s-D"),
                run: new ActionBarButton('assets/icons/run.png', () => {
                    return interact(new DrawRunInteraction()
                        .onCommit(step => self.editor.value.add(step))
                        .setStartPosition(self.state.value().position?.tile));
                }).tooltip("Run")
                    .setHotKey("s-R"),
                redclick: new ActionBarButton('assets/icons/cursor_redclick.png', () => {
                    return interact(new PlaceRedClickInteraction()
                        .onCommit((step) => self.editor.value.add(step)));
                }).tooltip("Redclick")
                    .setHotKey("s-C"),
                powerburst: new ActionBarButton('assets/icons/accel.png', () => {
                    if (self.state.value().position?.tile) {
                        this.editor.value.add(({
                            type: "powerburst",
                            where: self.state.value().position.tile
                        }));
                    }
                    else {
                        return interact(new PlacePowerburstInteraction()
                            .onCommit((step) => self.editor.value.add(step)));
                    }
                })
                    .tooltip("Powerburst of Acceleration")
                    .setHotKey("s-P"),
                cheat: new ActionBarButton('assets/icons/Rotten_potato.png', (e) => {
                    return interact(new DrawCheatInteraction(self.state.value().position?.tile)
                        .onCommit((step) => self.editor.value.add(step)));
                }).tooltip("Cheat"),
                cosmetic: new ActionBarButton('assets/icons/notes.png', (e) => {
                    return interact(new DrawCosmeticInteraction()
                        .onCommit((step) => self.editor.value.add(step)));
                }).tooltip("Cosmetic"),
            };
            this.bar = new ActionBar([
                this.buttons.surge,
                this.buttons.escape,
                this.buttons.dive,
                this.buttons.barge,
                this.buttons.run,
                this.buttons.redclick,
                this.buttons.powerburst,
                this.buttons.cheat,
                this.buttons.cosmetic
            ]).appendTo(this.content.body);
        }
        this.state.subscribe((s) => this.render(s), true);
    }
    render(state) {
        this.buttons.surge.cooldown.set(movement_state.nextAvailableCharge(state, "surge").remaining_cooldown);
        this.buttons.escape.cooldown.set(movement_state.nextAvailableCharge(state, "escape").remaining_cooldown);
        this.buttons.barge.cooldown.set(movement_state.nextAvailableCharge(state, "barge").remaining_cooldown);
        this.buttons.dive.cooldown.set(movement_state.nextAvailableCharge(state, "dive").remaining_cooldown);
        this.buttons.powerburst.cooldown.set(Math.max(state.acceleration_activation_tick + 120 - state.tick, 0));
    }
    eventKeyDown(event) {
        event.onPre(() => {
            const e = event.original;
            const handled = (() => {
                if (e.shiftKey && e.key.toLowerCase() == "w") {
                    this.editor.action_bar.buttons.surge.trigger();
                    return true;
                }
                else if (e.shiftKey && e.key.toLowerCase() == "s") {
                    this.editor.action_bar.buttons.escape.trigger();
                    return true;
                }
                else if (e.shiftKey && e.key.toLowerCase() == "d") {
                    this.editor.action_bar.buttons.barge.trigger();
                    return true;
                }
                else if (e.key.toLowerCase() == "d") {
                    this.editor.action_bar.buttons.dive.trigger();
                    return true;
                }
                else if (e.shiftKey && e.key.toLowerCase() == "r") {
                    this.editor.action_bar.buttons.run.trigger();
                    return true;
                }
                else if (e.shiftKey && e.key.toLowerCase() == "c") {
                    this.editor.action_bar.buttons.redclick.trigger();
                    return true;
                }
                else if (e.shiftKey && e.key.toLowerCase() == "p") {
                    this.editor.action_bar.buttons.powerburst.trigger();
                    return true;
                }
            })();
            if (handled) {
                event.stopAllPropagation();
                e.preventDefault();
            }
        });
    }
}
